/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Invoice_Update_SuccessInputs */

const vi_toast_invoice_update_success = /** @type {(inputs: Toast_Invoice_Update_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu cài đặt hóa đơn`)
};

/**

* @param {Toast_Invoice_Update_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_invoice_update_success = /** @type {((inputs?: Toast_Invoice_Update_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Invoice_Update_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_invoice_update_success(inputs)
});